"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _CRMToContactsObjectT;

var CRMToContactsObjectTypes = (_CRMToContactsObjectT = {}, (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.COMPANY, 'Companies'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.CONTACT, 'Contacts'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.DEAL, 'Deals'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.ENGAGEMENT, 'Engagements'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.FEEDBACK_SUBMISSION, 'Feedback Submissions'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.LINE_ITEM, 'Line Item'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.PRODUCT, 'Product'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.QUOTE, 'Quotes'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.TASK, 'Tasks'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.TICKET, 'Tickets'), (0, _defineProperty2.default)(_CRMToContactsObjectT, _ObjectTypes.default.VISIT, 'Visits'), _CRMToContactsObjectT);
Object.keys(_ObjectTypes.default).forEach(function (key) {
  (0, _invariant.default)(Object.prototype.hasOwnProperty.call(CRMToContactsObjectTypes, key), 'CRMToContactsObjectTypes: "%s" is defined in ObjectTypes but not in CRMToContactsObjectTypes', key);
});
var _default = CRMToContactsObjectTypes;
exports.default = _default;
module.exports = exports.default;